export const ADD_FLOW: string = "ADD_FLOW";
export const CLEAR_FLOWS: string = "CLEAR_FLOWS";
export function addFlow(flowName:string,template:string,medium:number[] ,validity:number,status:number): IAddFlowActionType {
    return { type: ADD_FLOW, flowName:flowName, template: template, medium:medium,validity:validity,status:status};
}
export function clearFlows(): IClearFlowActionType {
    return { type: CLEAR_FLOWS};
}


interface IAddFlowActionType { 
    type:string,
    flowName:string,
    template:string,
    medium:number[],
    validity:number,
    status:number 
}

interface IClearFlowActionType { 
    type:string 
}